document.addEventListener("DOMContentLoaded", () => {
  const chatBoxes = document.querySelectorAll(".chat-box");
  if (!chatBoxes.length) return;

  chatBoxes.forEach((chatBox) => {
    const messages = chatBox.querySelectorAll(".chat-message");
    if (!messages.length) return;

    let animationStarted = false;

    const startChatAnimation = () => {
      if (animationStarted) return;
      animationStarted = true;

      messages.forEach((message, index) => {
        // Si tu veux utiliser ton data-delay Liquid :
        // const delay = parseInt(message.dataset.delay || 0, 10);
        const delay = index * 2500; // délai entre chaque message

        const bubble = message.querySelector(".chat-bubble");
        if (!bubble) return;

        const typing = bubble.querySelector(".typing-indicator");
        const text = bubble.querySelector("p");

        setTimeout(() => {
          message.classList.add("visible");
          if (typing) typing.style.display = "flex";

          setTimeout(() => {
            if (typing) typing.style.display = "none";
            if (text) text.style.display = "block";
          }, 1500);
        }, delay);
      });
    };

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startChatAnimation();
            // On arrête d'observer ce bloc une fois l'animation lancée
            observerInstance.unobserve(chatBox);
          }
        });
      },
      {
        threshold: 0.3, // ~30% visible
      }
    );

    observer.observe(chatBox);
  });
});
